export class DeviceVM {
  Id: string;
  Notes: string;
  IsDownloaded = false;
}
